import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, Maximize2, Minimize2 } from 'lucide-react';
import type { ReactNode } from 'react';

interface GridCardProps {
  id: string;
  span: 1 | 2;
  onToggleSpan: (id: string) => void;
  children: ReactNode;
}

export function GridCard({ id, span, onToggleSpan, children }: GridCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 10 : 'auto' as any,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`relative group ${span === 2 ? 'md:col-span-2' : ''}`}
    >
      <div className="bg-bg-card border border-border rounded-lg p-4 h-full">
        {/* Toolbar: drag handle + resize toggle */}
        <div className="absolute top-2 right-2 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={() => onToggleSpan(id)}
            className="p-1 rounded text-text-muted hover:text-text-primary hover:bg-bg-hover transition-colors hidden md:block"
            title={span === 1 ? 'Expand to full width' : 'Shrink to half width'}
          >
            {span === 1 ? <Maximize2 size={12} /> : <Minimize2 size={12} />}
          </button>
          <button
            ref={setActivatorNodeRef}
            {...listeners}
            {...attributes}
            className="cursor-grab active:cursor-grabbing p-1 rounded text-text-muted hover:text-text-primary hover:bg-bg-hover transition-colors"
            title="Drag to reorder"
          >
            <GripVertical size={12} />
          </button>
        </div>

        {children}
      </div>
    </div>
  );
}
